import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, Music2Icon } from 'lucide-react'; // Music2Icon as placeholder for TikTok
export function Footer() {
  return <footer className="bg-[#FFF8F0] pt-16 pb-8" data-id="element-99">
      <div className="container mx-auto px-4 md:px-8" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16 text-center md:text-left" data-id="element-101">
          {/* Col 1 */}
          <div className="flex flex-col items-center md:items-start" data-id="element-102">
            <Link to="/" className="flex items-center mb-4" data-id="element-103">
              <span className="font-heading text-3xl font-bold text-[#2D1A1A]" data-id="element-104">
                Butter Blonde
              </span>
              <span className="text-[#F5D76E] ml-1 text-2xl" data-id="element-105">✦</span>
            </Link>
            <p className="font-script text-2xl text-[#E91E8C]" data-id="element-106">
              Stack your story
            </p>
          </div>

          {/* Col 2 */}
          <div className="flex flex-col items-center md:items-start" data-id="element-107">
            <h4 className="font-body font-bold text-[#6B1D4A] uppercase tracking-wider mb-6" data-id="element-108">
              Explore
            </h4>
            <nav className="flex flex-col space-y-4" data-id="element-109">
              <Link to="/" className="font-body text-[#2D1A1A] hover:text-[#E91E8C] transition-colors" data-id="element-110">
                Home
              </Link>
              <Link to="/collections" className="font-body text-[#2D1A1A] hover:text-[#E91E8C] transition-colors" data-id="element-111">
                Collections
              </Link>
              <Link to="/about" className="font-body text-[#2D1A1A] hover:text-[#E91E8C] transition-colors" data-id="element-112">
                About
              </Link>
              <Link to="/contact" className="font-body text-[#2D1A1A] hover:text-[#E91E8C] transition-colors" data-id="element-113">
                Contact
              </Link>
              <a href="https://shop.butter-blonde.com" target="_blank" rel="noopener noreferrer" className="font-body text-[#2D1A1A] hover:text-[#E91E8C] transition-colors" data-id="element-114">
                Shop
              </a>
            </nav>
          </div>

          {/* Col 3 */}
          <div className="flex flex-col items-center md:items-start" data-id="element-115">
            <h4 className="font-body font-bold text-[#6B1D4A] uppercase tracking-wider mb-6" data-id="element-116">
              Stay in the loop
            </h4>
            <p className="font-body text-[#2D1A1A] opacity-80 mb-4 max-w-xs" data-id="element-117">
              Join our list for early access to new collections and exclusive
              stacking tips.
            </p>
            <form className="flex w-full max-w-sm flex-col sm:flex-row gap-2" onSubmit={e => e.preventDefault()} data-id="element-118">
              <input type="email" placeholder="Email address" className="flex-grow h-12 px-4 rounded-full border border-[#F8C8DC] bg-white font-body focus:outline-none focus:ring-2 focus:ring-[#E91E8C]" required data-id="element-119" />
              <button type="submit" className="h-12 px-6 rounded-full bg-[#E91E8C] text-white font-body font-medium hover:bg-[#C21472] transition-colors" data-id="element-120">
                Join
              </button>
            </form>

            <div className="flex space-x-4 mt-8" data-id="element-121">
              <a href="#" className="w-10 h-10 rounded-full bg-[#F8C8DC] flex items-center justify-center text-[#6B1D4A] hover:bg-[#E91E8C] hover:text-white transition-colors" data-id="element-122">
                <InstagramIcon className="w-5 h-5" data-id="element-123" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#F8C8DC] flex items-center justify-center text-[#6B1D4A] hover:bg-[#E91E8C] hover:text-white transition-colors" data-id="element-124">
                <Music2Icon className="w-5 h-5" data-id="element-125" />
              </a>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-126">
          <p className="font-body text-sm text-[#2D1A1A] opacity-60" data-id="element-127">
            © 2026 Butter Blonde. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}